import { render, staticRenderFns } from "./ModalCategoryCar.vue?vue&type=template&id=383e4233"
import script from "./ModalCategoryCar.vue?vue&type=script&lang=js"
export * from "./ModalCategoryCar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports